const constants = {
  style: {
    mobileScreenWidth: "750px",
    mobileAndDownMediaQuery: "only screen and (max-width : 750px)",
    mobileAndUpMediaQuery: "only screen and (min-width : 750px)",
  },
};

export default constants;
